import script from "./MoveablePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveablePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MoveablePanel.vue?vue&type=style&index=0&id=68252e2c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68252e2c"]])

export default __exports__